import axios from '@axios'
import { assign } from 'lodash'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('stations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`stations/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        assign: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('allocate', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        allocate: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('allocate_users', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('main_warehouses', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        users: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('stationed_users', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
